import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { environment } from '../environments/environment';
import { A11yPageComponent } from './core/components/a11y-page/a11y-page.component';
import { PageBadRequestComponent } from './core/components/page-bad-request/page-bad-request.component';
import { PageInternalServerErrorComponent } from './core/components/page-internal-server-error/page-internal-server-error.component';
import { PageNotFoundComponent } from './core/components/page-not-found/page-not-found.component';
import { PageServiceUnavailableComponent } from './core/components/page-service-unavailable/page-service-unavailable.component';
import { CookiebeleidComponent } from './shared/components/cookiebeleid/cookiebeleid.component';
import { RedirectGuard } from './shared/guards/redirect.guard';

const routes: Routes = [
    {
        path: '',
        component: RedirectGuard,
        pathMatch: 'full',
        data: {
            redirectUrl: environment.portalSite
        },
        canActivate: [RedirectGuard]
    },
    {
        path: 'flows',
        loadChildren: () => import('./flows/flows.module').then(m => m.FlowsModule)
    },
    {
        path: 'toegankelijkheidsverklaring',
        component: A11yPageComponent
    },
    {
        path: 'cookie-declaration',
        redirectTo: '/cookiebeleid'
    },
    {
        path: 'cookiebeleid',
        component: CookiebeleidComponent },
    {
        path: '400',
        component: PageBadRequestComponent
    },
    {
        path: '404',
        component: PageNotFoundComponent
    },
    {
        path: '500',
        component: PageInternalServerErrorComponent
    },
    {
        path: '503',
        component: PageServiceUnavailableComponent
    },
    {path: '**', redirectTo: '404'}
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {
        anchorScrolling: 'enabled',
        scrollPositionRestoration: 'enabled'
    })],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
